// extracted by mini-css-extract-plugin
export default {"input":"styles_input__Doaic","suggest":"styles_suggest__mQAqm","error":"styles_error__qvTDg","fit":"styles_fit__G4e9i"};